import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=087037d1&scoped=true&"
import script from "./FileSystem.vue?vue&type=script&lang=js&"
export * from "./FileSystem.vue?vue&type=script&lang=js&"
import style0 from "./FileSystem.vue?vue&type=style&index=0&id=087037d1&scoped=true&lang=scss&"
import style1 from "./FileSystem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087037d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
